import React, { useState,useEffect } from "react";
import {IMenuTree } from '../models/General';
import {Link } from "react-router-dom";

export default function Family(prop:any) {
    const family = prop.familyTree
    const padding = prop.padding + 24
    const [isVisible, setIsVisible] = useState(false);
    const expand = () => {
      setIsVisible(!isVisible);
    };


    return (
        <React.Fragment>
            {
                <React.Fragment >
                    <ul className="nav nav-pills nav-sidemenu flex-column" data-widget="treeview" role="menu" data-accordion="false">
                        <li key={family.MENU_ID} className={"nav-item menu-open"} >
                            {
                                typeof family?.CHILD == "undefined" ?
                                <Link to={family.LINK} style={ { paddingLeft: `${ padding }px` } } className="nav-link" >
                                    <span className="nav-label">{family.MENU_NAME}</span>
                                </Link>
                                : 
                                <React.Fragment key={family.MENU_ID}>
                                    <a onClick={expand} style={ { paddingLeft: `${ padding }px` } } href="#" className="nav-link">                                    
                                        <p>
                                            <span className="nav-label">{family.MENU_NAME}</span>
                                            <i style={{right: '1.3rem'}} className={`right fas ${isVisible ? "fa-angle-right" : "fa-angle-left"}`}></i>
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview" style={{background: '#000c17'}}>
                                        {isVisible && typeof family?.CHILD != "undefined" ? (
                                            Object.keys(family?.CHILD).map((key:any) => family.CHILD[key]).map(((child) => {
                                                if(child.PARENT_ID == family.MENU_ID){
                                                    if(child.CHILD && typeof child.CHILD != 'undefined'){
                                                        return (
                                                            <Family key={child.MENU_ID} familyTree={child} padding={padding} />
                                                        )
                                                    }
                                                    else{
                                                        return(
                                                            <li className="nav-item" key={child.MENU_ID}>
                                                                <Link to={child.LINK} style={ { paddingLeft: `${ padding +24 }px` } } className="nav-link" >
                                                                    {/* <i className="far fa-circle nav-icon"></i>  */}
                                                                    <span className="nav-label">{child.MENU_NAME}</span>
                                                                </Link>
                                                            </li>
                                                        )
                                                    }
                                                }
                                            })
                                        )) : (
                                        <></>
                                        )}
                                    </ul>  
                                </React.Fragment>
                            }
                        </li>
                    </ul>
                </React.Fragment>
            }  
        </React.Fragment>
      );
}